import React from 'react';
import { TitleHeader } from 'web-library';
import { TFunction } from 'react-i18next';
import { ExamRegistrationType } from '../api/candidate/exam/model';

interface IRenderTitleHeader {
  examRegistrationType: ExamRegistrationType | undefined;
  t: TFunction<'translation'>;
}
const GroupExamRegistrationTitleHeader = ({ examRegistrationType, t }: IRenderTitleHeader) => (
    <>
      {examRegistrationType === ExamRegistrationType.SUPPLEMENTARY ? (
        <TitleHeader title={t('exam->>SupplementaryRegistration.RegisterForAnExamSupplementary')} />
      ) : (
        <TitleHeader title={t('exam->>RegisterExam.RegisterForAnExam')} />
      )}
    </>
  );

export default GroupExamRegistrationTitleHeader;
